import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
type CtaButtonProps = {
  children: React.ReactNode;
  size?: 'md' | 'lg';
  variant?: 'solid' | 'light';
  className?: string;
};
export function CtaButton({
  children,
  size = 'lg',
  variant = 'solid',
  className = ''
}: CtaButtonProps) {
  const reduceMotion = useReducedMotion();
  const sizeClasses = size === 'lg' ? 'px-8 py-4 text-base sm:text-lg' : 'px-6 py-3 text-sm sm:text-base';
  const variantClasses = variant === 'solid' ? 'bg-mint-600 text-white hover:bg-mint-700 focus-visible:outline-mint-700' : 'bg-white text-mint-800 ring-1 ring-inset ring-mint-300 hover:bg-mint-50 focus-visible:outline-mint-600';
  return <motion.a href="#oferta" animate={reduceMotion ? undefined : {
    scale: [1, 1.04, 1]
  }} transition={reduceMotion ? undefined : {
    duration: 1.6,
    ease: 'easeInOut',
    repeat: Infinity
  }} whileHover={reduceMotion ? undefined : {
    scale: 1.06
  }} whileTap={reduceMotion ? undefined : {
    scale: 0.98
  }} className={`group inline-flex items-center justify-center gap-2.5 rounded-full font-semibold shadow-soft transition-[background-color,box-shadow] duration-150 ease-out hover:shadow-lift focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 ${sizeClasses} ${variantClasses} ${className}`} data-id="element-47" data-mp="vbsg5phrmwcr">
      <span data-id="element-48" data-mp="3ow0a8kjdlkh2">{children}</span>
      <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-49" data-mp="3owtkvwlggu4h" />
    </motion.a>;
}